import React from 'react'

type Direction = 'next' | 'previous'

type UseCursorPagination = {
  direction: Direction
  setDirection: React.Dispatch<React.SetStateAction<Direction>>
  cursor: string | undefined
  setCursor: React.Dispatch<React.SetStateAction<string | undefined>>
}

export const useCursorPagination = (): UseCursorPagination => {
  const [direction, setDirection] = React.useState<Direction>('next')
  const [cursor, setCursor] = React.useState<string | undefined>(undefined)

  return {
    cursor,
    setCursor,
    direction,
    setDirection,
  }
}
